import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {User} from 'main/stores/users';
import {fullName} from 'shared/tools';

class CustomReportShare extends DomainObject {
  id;
  user;
  _destroy;

  _relations = {
    user: User
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      user: observable,
      _destroy: observable,
      userId: computed,
      name: computed
    });

    this.merge(other);
  }

  get userId() {
    return this.user.id;
  }

  get name() {
    return fullName(this.user);
  }
}

export default CustomReportShare;
